import ManagePendingRequest from './ManagePendingRequest';

export default ManagePendingRequest;



// WEBPACK FOOTER //
// ./src/components/Modals/ManagePendingRequest/index.jsx